import { get } from '../http';

export const getprofileByGolfId = golfId => get(`profiles/golfid/${golfId}`);
export const getprofileEmail = email => get(`v2/profiles/email/${email}`);
